import DashboardCard from "@components/DashboardCard";

import { useTokenBalance, useTVL, useExchangeRate } from "dapp-sdk";

import { formatNumber } from "@utils/globalCommon";
import { useMemo } from "react";
import { toFixedWithoutRounding } from "@utils/common";

const Dashboard = () => {
  const { token, xtoken } = useTokenBalance();

  const conversionData = useExchangeRate({});
  const conversions = useMemo(() => {
    const conversionToERC20 = conversionData?.exchangeRate;
    return {
      toERC20: conversionToERC20
        ? +toFixedWithoutRounding(conversionToERC20.toString(), 4)
        : 0,
    };
  }, [conversionData?.exchangeRate]);

  const tvlData = useTVL({});

  return (
    <>
      {conversions.toERC20 && tvlData?.tvl ? (
        <DashboardCard
          title="Dashboard"
          xToken={xtoken.symbol}
          erc20Token={token.symbol}
          xTokens={formatNumber(Number(xtoken.balance), false, 4) || "0"}
          exchangeRate={conversions.toERC20.toString()}
          erc20Tokens={
            formatNumber(
              Number(xtoken.balance * conversions.toERC20),
              false,
              4
            ) || "0"
          }
          erc20TokensMarketValue={
            formatNumber(
              Number(
                xtoken.balance * conversions.toERC20 * tvlData.tvl.usdPrice
              ),
              false,
              4
            ) || "0"
          }
        />
      ) : null}
    </>
  );
};

export default Dashboard;
